import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { debounceTime, fromEvent, Subscription } from 'rxjs';

@Component({
  selector: 'rx-scrollable',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './rx-scrollable.component.html',
  styleUrls: ['./rx-scrollable.component.scss'],
})
export class RxScrollableComponent implements AfterViewInit, OnDestroy, OnChanges {
  @Output() scrollNearEnd = new EventEmitter<void>();
  @Input() scrollThreshold = 100; // Pixels from bottom to trigger
  @Input() loading = false;

  @ViewChild('scrollContainer', { static: false }) scrollContainer: ElementRef;

  private scrollSubscription: Subscription;

  ngAfterViewInit() {
    if (this.scrollContainer) {
      this.scrollSubscription = fromEvent(this.scrollContainer.nativeElement, 'scroll')
        .pipe(debounceTime(200))
        .subscribe(() => this.handleNativeScroll());
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // This just syncs if loading value changes from the parent
    if (changes['loading']) {
      this.loading = changes['loading'].currentValue;
    }
  }

  handleNativeScroll() {
    if (!this.scrollContainer || this.loading) return;

    const element = this.scrollContainer.nativeElement;
    const distanceFromBottom = element.scrollHeight - element.scrollTop - element.clientHeight;

    if (distanceFromBottom < this.scrollThreshold) {
      this.scrollNearEnd.emit();
    }
  }

  ngOnDestroy() {
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }
  }
}
